{% block swag_paypal_pos_wizard_connection_success %}
    <div class="swag-paypal-pos-wizard-connection-success">

        {% block swag_paypal_pos_wizard_connection_success_headline_content %}
            <div class="swag-paypal-pos-wizard-connection-success__content">

                {% block swag_paypal_pos_wizard_connection_success_icon %}
                    <div class="swag-paypal-pos-wizard-connection-success__icon-wrapper">
                        <mt-icon class="swag-paypal-pos-wizard-connection-success__icon"
                                 name="regular-thumbs-up"
                                 size="80px"
                                 color="#37D046" />
                    </div>
                {% endblock %}

                {% block swag_paypal_pos_wizard_connection_success_headline %}
                    <div class="swag-paypal-pos-wizard-connection-success__headline">
                        {{ $t('swag-paypal-pos.wizard.connectionSuccess.headline') }}
                    </div>
                {% endblock %}

                {% block swag_paypal_pos_wizard_connection_success_info %}
                    <div class="swag-paypal-pos-wizard-connection-success__info">
                        {{ $t('swag-paypal-pos.wizard.connectionSuccess.info') }}
                    </div>
                {% endblock %}

                {% block swag_paypal_pos_wizard_connection_success_user %}
                    <mt-card class="swag-paypal-pos-wizard-connection-success__user"
                             position-identifier="swag-paypal-pos-wizard-connection-success-user"
                             :isLoading="isFetchingInformation">
                        <sw-container class="swag-paypal-pos-wizard-connection-success__user-container"
                                      columns="30px auto auto"
                                      align="center"
                                      gap="30px">

                            {% block swag_paypal_pos_wizard_connection_success_user_avatar %}
                                <sw-avatar
                                        class="swag-paypal-pos-wizard-connection-success__user-avatar"
                                        size="40px"
                                        :firstName="posUser.firstName"
                                        :lastName="posUser.lastName" />
                            {% endblock %}

                            {% block swag_paypal_pos_wizard_connection_success_user_information %}
                                <div class="swag-paypal-pos-wizard-connection-success__user-info">

                                    {% block swag_paypal_pos_wizard_connection_success_user_information_real %}
                                        <div class="swag-paypal-pos-wizard-connection-success__user-info-name">
                                            {{ posUser.fullName }}
                                        </div>
                                        <div class="swag-paypal-pos-wizard-connection-success__user-info-mail">
                                            {{ posUser.mail }}
                                        </div>
                                    {% endblock %}
                                </div>
                            {% endblock %}

                            {% block swag_paypal_pos_wizard_connection_success_user_disconnect_button %}
                                <mt-button class="swag-paypal-pos-wizard-connection-success__user-disconnect"
                                           ghost
                                           size="small"
                                           variant="secondary"
@click="onDisconnect">
                                    {{ $t('swag-paypal-pos.wizard.connectionSuccess.disconnectButton') }}
                                </mt-button>
                            {% endblock %}
                        </sw-container>
                    </mt-card>
                {% endblock %}
            </div>
        {% endblock %}

        {% block swag_paypal_pos_wizard_connection_success_disclaimer %}
            <div class="swag-paypal-pos-wizard-connection-success__disclaimer">
                {{ $t('swag-paypal-pos.wizard.connectionSuccess.disclaimer') }}
            </div>
        {% endblock %}
    </div>
{% endblock %}
